import React, { createContext, useEffect, useState, useMemo } from 'react';
//api
import { getBlogCategoriesNotPaginated } from 'api/blog';

//helpers
export const MenuContext = createContext();

const MenuContextProvider = (props) => {
  const [blogCategories, setBlogCategories] = useState([]);

  const getMenuBlogCategories = async (with_post = null) => {
    const { data, status } = await getBlogCategoriesNotPaginated({
      with_post
    });
    if (status === 200) {
      setBlogCategories(data);
    }
  };

  useEffect(() => {
    getMenuBlogCategories(true);
  }, []);

  const values = useMemo(
    () => ({
      blogCategories,
      refreshCategories: getMenuBlogCategories,
    }),
    [blogCategories],
  );

  return <MenuContext.Provider value={values}>{props.children}</MenuContext.Provider>;
};

export default MenuContextProvider;
